export default function LevelSection({ level,}) {
    
    return (
        <>
            <div className="puzzle-level">
                <img
                    className="game-heading"
                    src={`${process.env.PUBLIC_URL}/assets/images/puzzle/level.png`}
                    alt="Level Icon"
                />
                <span className="game-level">
                    {level}
                </span>

            </div>
        </>

    );
}